import React from 'react';
import { useText } from '../../lib/siteContent';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { responsiveImg } from '../../lib/imageUrl';
import { useSlotImage } from '../../lib/useSlotImage';
import { TextLink } from './TextLink';

const CATEGORIES = [
  { key: 'weddings', label: 'Weddings', slot: 'realisations-weddings', to: '/univers/weddings' },
  { key: 'receptions', label: 'Réceptions privées', slot: 'realisations-receptions', to: '/univers/receptions-corporate' },
  { key: 'heritage', label: 'JBMH Héritage', slot: 'realisations-heritage', to: '/univers/heritage' },
  { key: 'corporate', label: 'Corporate', slot: 'realisations-corporate', to: '/univers/receptions-corporate' },
];

const OFFSETS = ['', 'lg:mt-20', '', 'lg:mt-20'];

const CategoryTile = ({ c, i }) => {
  const src = useSlotImage(c.slot, null);
  const t = useText();
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 1, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={OFFSETS[i]}
    >
      <Link to={c.to} className="group block" data-testid={`realisations-cat-${c.key}`}>
        <div className="aspect-[3/4] overflow-hidden bg-[#F5F5F5]">
          {src && (
            <img
              {...responsiveImg(src, '(max-width: 768px) 100vw, 33vw')}
              alt={`${t(`real.cat.${c.key}`)} — image d'illustration`}
              className="w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.03]"
            />
          )}
        </div>
        <span className="mt-6 block text-[11px] uppercase tracking-[0.3em] text-[#111111] group-hover:text-[#6B6B6B] transition-colors duration-500">
          {t(`real.cat.${c.key}`)}
        </span>
      </Link>
    </motion.div>
  );
};

const RealisationsSection = () => {
  const t = useText();
  return (
  <section id="realisations" className="bg-[#FFFFFF] pt-32 md:pt-48 pb-8" data-testid="realisations-section">
    <div className="container-custom">
      <div className="grid grid-cols-1 lg:grid-cols-[7fr_5fr] gap-10 lg:gap-20 items-end mb-20 md:mb-28">
        <div>
          <span className="block text-[11px] uppercase tracking-[0.3em] text-[#111111] mb-8">{t('real.label')}</span>
          <h2 className="font-serif font-light text-[#111111] text-5xl sm:text-6xl lg:text-7xl leading-[1.02]" data-testid="realisations-headline">
            <span className="whitespace-pre-line">{t('real.headline')}</span>
          </h2>
        </div>
        <p className="text-sm md:text-base leading-[1.9] font-light text-[#333333] max-w-md" data-testid="realisations-intro">
          {t('real.intro')}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 xl:gap-x-8 gap-y-14">
        {CATEGORIES.map((c, i) => <CategoryTile key={c.key} c={c} i={i} />)}
      </div>
      <div className="mt-16 md:mt-20">
        <TextLink to="/realisations" testId="realisations-cta">{t('real.cta')}</TextLink>
      </div>
    </div>
  </section>
  );
};

export default RealisationsSection;
